import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Stack, ThemeProvider, Typography } from '@mui/material';

import { passengerThemeV2 } from '@mopla/mui';
import { DTicketPageLayout } from '@mopla/ui';

import { usePassengerAppNavigate } from '../../../hooks';

import { DTicketCancelSuccessModal } from './DTicketCancelSuccessModal';
import { DTicketSubscriptionCancelForm } from './DTicketSubscriptionCancelForm';
import { DTicketSubscriptionCancelSkeleton } from './DTicketSubscriptionCancelSkeleton';
import { useDTicketSubscriptionCancel } from './hooks';

export const DTicketSubscriptionCancel = () => {
	const { t } = useTranslation('dticketSubscriptionCancel');
	const { navigateToUserDTicket } = usePassengerAppNavigate();

	const {
		isSubscriptionLoading,
		isCancelLoading,
		isSuccessModalOpen,
		successModalVariant,
		cancellationCase,
		dates,
		hasPendingCancel,
		handleCancel,
		closeSuccessModal,
	} = useDTicketSubscriptionCancel();

	// Redirect away if there is nothing to cancel,
	// or if a cancellation is already scheduled (canceledAt !== null)
	useEffect(() => {
		if (!isSubscriptionLoading && (!dates || hasPendingCancel)) {
			navigateToUserDTicket();
		}
	}, [isSubscriptionLoading, dates, hasPendingCancel, navigateToUserDTicket]);

	const isLoading = isSubscriptionLoading || !dates || hasPendingCancel;

	return (
		<ThemeProvider theme={passengerThemeV2}>
			<DTicketPageLayout
				title={t('page_title')}
				onBack={navigateToUserDTicket}
				scrollable={true}
				dataTestId="dticket-subscription-cancel-page"
			>
				{isLoading ? (
					<DTicketSubscriptionCancelSkeleton />
				) : (
					<Stack gap={3}>
						<Typography variant="h4-sb" color="primary.main">
							{t('section_title')}
						</Typography>

						<DTicketSubscriptionCancelForm
							onSubmit={handleCancel}
							isLoading={isCancelLoading}
							dates={dates}
							cancellationCase={cancellationCase}
						/>
					</Stack>
				)}
			</DTicketPageLayout>

			{dates && (
				<DTicketCancelSuccessModal
					open={isSuccessModalOpen}
					onClose={closeSuccessModal}
					variant={successModalVariant}
					dates={dates}
				/>
			)}
		</ThemeProvider>
	);
};
